// src/components/Home.js

import React from 'react';

const Home = () => {
  return (
    <div>
      <h2>Benvenuto in FitLab!</h2>
      <p>Qui puoi gestire le tue schede di allenamento e molto altro.</p>
    </div>
  );
};

export default Home;
